import { useMemo } from 'react';
import { RenderSection } from '../../components';
import { useKeywords } from 'shared/hooks/knowledge-content.hooks';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';
import { Select } from 'src/components/design-system';

export function RenderKeywordsSelector({
  setFieldValue = () => {},
  knowledgeKeywords = [],
  keywords = [],
}) {
  const lang = useSelector(getLang('KNOWLEDGE_EDITOR'));
  const { suggestedKeywords } = useKeywords({ keywords: knowledgeKeywords });

  const options = useMemo(
    () => suggestedKeywords.map(keyword => ({ value: keyword, label: keyword })),
    [suggestedKeywords],
  );

  return (
    <RenderSection header={lang.KEYWORDS}>
      <Select
        value={keywords}
        options={options}
        name="keywords"
        placeholder={lang.KEYWORDS_PLACEHOLDER}
        onChange={setFieldValue}
        mode="tags"
      />
    </RenderSection>
  );
}
